import {GenericRequest, getUrlEndpointPrivate} from '@cuatroochenta/co-admin-react-library';
import {
    BulletinListExportPdfRequest
} from '../request/BulletinListExportPdfRequest';

export default class TaskBulletinListExportPdf extends GenericRequest {

    private readonly data;

    public constructor(data: BulletinListExportPdfRequest) {
        super('POST' as any, getUrlEndpointPrivate('bulletins/export-pdf'));
        this.data = data;
    }

    public overrideRequest() {
        return {criteria: this.data};
    }
}